import { LockClosedIcon, ArrowRightIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

export const ContentLocked = () => {
  return (
    <div className="absolute flex w-full h-full backdrop-blur-md items-center justify-center p-4 !pt-12">
      <div className="relative w-96 h-52 bg-white rounded-2xl shadow-2xl pt-10 px-4 pb-3 flex flex-col items-center justify-between gap-3">
        <div className="w-full flex flex-col flex-1 gap-3 items-center justify-center">
          <p className="text-lg font-bold"> Content Locked</p>
          <p className="text-grey-700 max-w-full text-center">
            Please purchase a package to get access to this information.
          </p>
        </div>
        <Link
          to="/portal/packages"
          className="w-full !py-2 !gap-2 flex justify-center items-center rounded-full text-base font-bold text-white text-center bg-primary"
        >
          <span>Get a package</span>
          <ArrowRightIcon className="w-5 aspect-square text-white stroke-medium" />
        </Link>
        <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 rounded-t-full shadow-[0_-2px_2px_rgba(0,0,0,0.1)] bg-white w-[72px] h-10">
          <div className="absolute top-1 left-1/2 transform -translate-x-1/2 grid place-items-center w-16 aspect-square bg-primary rounded-full">
            <LockClosedIcon className="w-9 min-w-9 text-white" />
          </div>
        </div>
      </div>
    </div>
  );
};
